// utils/calculateTotalPriceWithShippingCost.js

export function getShippingCost(totalPrice) {
    //return totalPrice > 70 ? totalPrice * 0.065 : 5;
    return 5;
}

export function calculateTotalPriceWithShippingCost(totalPrice) {
    const shippingCost = getShippingCost(totalPrice);
    return totalPrice + shippingCost;
}
